import React, {Component} from 'react';
import PostsListRow from './PostsListRow';


class PostsList extends Component {
    state = {
        platformsEnabled: this.props.platformsEnabled, user: this.props.user
    }

    //console.log('PostsList detailsGlobal ', detailsGlobal);
    //console.log('PostsList posts ', posts);
    componentDidUpdate = async () => {
        if (this.state.platformsEnabled !== this.props.platformsEnabled) {
            await this.setState({
                platformsEnabled: this.props.platformsEnabled
            })
        }
        if (this.state.user !== this.props.user) {
            await this.setState({
                user: this.props.user
            })
        }
    }

    render() {

        let posts = this.props.posts

        return (<div className="posts row m-m-b">

            {posts && posts.map((post, index) => <React.Fragment key={index}>
                {/*{console.log('postsList- this source', thisSource)}*/}
                <PostsListRow
                    thisSource={this.props.thisSource}
                    post={post} detailsGlobal={this.props.detailsGlobal}
                    history={this.props.history}
                    fb_page_connected={this.props.fb_page_connected}
                    facebook_platform_enabled={this.props.facebook_platform_enabled}
                    webpush_platform_enabled={this.props.webpush_platform_enabled}
                    viberPlatformEnabled={this.props.viberPlatformEnabled}
                    platformsEnabled={this.props.platformsEnabled}
                    user={this.state.user}
                />
            </React.Fragment>)}


        </div>)

    }

}

export default PostsList

